/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Remark } from '../../models/remark';

export interface GetRemark$Params {
  remarkId: number;
}

export function getRemark(http: HttpClient, rootUrl: string, params: GetRemark$Params, context?: HttpContext): Observable<StrictHttpResponse<Remark>> {
  const rb = new RequestBuilder(rootUrl, getRemark.PATH, 'get');
  if (params) {
    rb.path('remarkId', params.remarkId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Remark>;
    })
  );
}

getRemark.PATH = '/api/v1/Remark/{remarkId}';
